export enum MarketingEmailType {
  PropertyBulletin = 0,
  PropertyDetails = 1,
  DevelopmentDetail = 2,
  Newsletter = 3,
  PropertyFeedbackRequest = 4,
}
